import { FormBase } from 'core/components';

export default class PatientAddModalForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'patientId',
                    label: 'FACILITY_ORDER_TEMPLATE.PATIENT_ADD_MODAL.PATIENT_NAME_LABEL',
                    placeholder: 'FACILITY_ORDER_TEMPLATE.PATIENT_ADD_MODAL.PATIENT_NAME_PLACEHOLDER',
                    rules: 'required|string'              
                },
                {
                    name: 'subCategoryId',
                    label: 'FACILITY_ORDER_TEMPLATE.PATIENT_ADD_MODAL.SUB_CATEGORY_NAME_LABEL',
                    placeholder: 'FACILITY_ORDER_TEMPLATE.PATIENT_ADD_MODAL.SUB_CATEGORY_NAME_PLACEHOLDER',
                    rules: 'required|string'              
                },
                {
                    name: 'referenceId',
                    label: 'FACILITY_ORDER_TEMPLATE.PATIENT_ADD_MODAL.REFERENCE_NAME_LABEL',
                    placeholder: 'FACILITY_ORDER_TEMPLATE.PATIENT_ADD_MODAL.REFERENCE_NAME_PLACEHOLDER',
                    rules: 'required|string'              
                }
            ],
        };
    }
}
